// removed by extract-text-webpack-plugin
module.exports = {"wrapper-loading__magazine":"magazines_1e8oK","wrapper-loading__magazine-book":"magazines_2SnJk","wrapper-loading__magazine-book-page":"magazines_1Q7d1","flip":"magazines_YUuWM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/styles.scss
// module id = 1035
// module chunks = 1